module.exports = __webpack_public_path__ + "static/media/shoes.9fe8100a.jpg";